module.exports = __webpack_public_path__ + "static/project-3b-badc70627d55042c2eeb76253e760124.png";